import { AutogenLayoutWorkersCompensationReport } from "./autogen/AutogenLayoutWorkersCompensationReport";

export class WorkersCompensationReport extends AutogenLayoutWorkersCompensationReport {
    
    /** Event handler for report type switch changes */
    reportTypeChanged(): void {
        const isDetailed = this.switchReportType ? this.switchReportType.checked : true;
        if(!isDetailed) {
            // Clear SSN option when switching to summary report
            this.checkboxIncludeSsn.checked = false;
            this.checkboxIncludeSsn.enabled = false;
        } else {
            this.checkboxIncludeSsn.enabled = true;
        }
    }

}